import React from 'react';

const Description = ({ description }) => {
  if (!description) return null;

  const isHtmlString = typeof description === 'string';

  return (
    <li className="medic-feature-profile-detail-list__item">
      <div className="medic-feature-profile-detail__title">Інформація про лікаря</div>
      <div className="medic-feature-profile-detail__description">
        {isHtmlString ? (
          <span dangerouslySetInnerHTML={{ __html: description }} />
        ) : (
          description
        )}
      </div>
    </li>
  );
};

export default Description;
